module.exports = __webpack_public_path__ + "img/7_newYouth_kbn.869eec8e.png";